import React from 'react';
import { Helmet } from 'react-helmet';
import {
  TERMS_DESC,
  TERMS_DESC_ES,
  TERMS_TITLE,
  TERMS_TITLE_ES
} from '../../constants/defaults';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

const TermsAndConditions = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext.data;
  const { i18n } = useTranslation();
  let isEs = _.isEqual(i18n.language, 'es');

  return (
    <main>
      <Helmet>
        {isEs ? <title>{TERMS_TITLE_ES}</title> : <title>{TERMS_TITLE}</title>}
        {isEs ? (
          <meta name="description" content={TERMS_DESC_ES} />
        ) : (
          <meta name="description" content={TERMS_DESC} />
        )}
        <link
          rel="alternate"
          href="https://www.singlecare.com/terms-and-conditions"
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com/es/terminos-y-condiciones"
          hrefLang="es-us"
        />
        <link
          rel="canonical"
          href={`https://www.singlecare.com${props.location.pathname}`}
        />
        <meta
          name="ROBOTS"
          content="NOINDEX, FOLLOW, NOSNIPPET, NOODP, NOYDIR"
        />
      </Helmet>
      <div
        id="static-page-content"
        dangerouslySetInnerHTML={{
          __html: data?.content
        }}
      ></div>
    </main>
  );
};

export default TermsAndConditions;
